const getDefaultState = () => {
  return {
    incidentList: [],
    mergeSearchKeyword: ''
  }
}
const state = getDefaultState()

const getters = {
  incidentList: (state) => {
    return state.incidentList
  },
  mergeSearchKeyword: (state) => {
    return state.mergeSearchKeyword
  }
}

const actions = {
  setIncidentList (context, list) {
    context.commit('setIncidentList', list)
  }
}

const mutations = {
  setIncidentList (state, list) {
    state.incidentList = list
  },
  setMergeSearchKeyword (state, keyword) {
    state.mergeSearchKeyword = keyword
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ticket/index.js